const Config = {
  Domain: process.env.REACT_APP_DOMAIN,
  Protocol: process.env.REACT_APP_PROTOCOL,
  ListLimit: 20,
  TickerRefreshMs: 120000, // Case Profile ticker recompute interval (2 min)

  getUrl: function () {
    return Config.Protocol + "://" + Config.Domain;
  },
  getHeaders: function () {
    const token = localStorage.getItem("jwttoken");
    return {
      Authorization: token,
    };
  },
};

export default Config;
